<template>
  <section class="bootcamp-preview">
    <h3 class="section-subtitle">{{ preview.subtitle }}</h3>
    <h2 class="section-title">{{ preview.title }}</h2>
    <p class="section-description">
      {{ preview.description }}
    </p>
    <ThePreviewContainer />
  </section>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  components: {
    ThePreviewContainer: () => import("@/components/bootcamp/enroll/preview/ThePreviewContainer"),
  },
  computed: {
    ...mapGetters("BootcampEnroll", ["bootcampPreviewByKey"]),
    key () {
      return this.$route.params.key || this.$route.path.replace("/", "")
    },
    preview () {
      return this.bootcampPreviewByKey(this.key)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
.bootcamp-preview {
  padding-top: 7.7rem;
  background: #f5f5fa;
  padding-bottom: 9rem;
  @include phone-down {
    background: transparent;
    border-top: 1px solid #d6d6e3;
    padding-bottom: 3rem;
  }
  @include tablet-down {
    padding-top: 4rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bootcamp/enroll/preview/TheBootcampPreview.vue